// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__4cb5g","vertical":"List_vertical__z9Pz7"};